module.exports = __webpack_public_path__ + "media/images/emblems/Kriegstetten-blason-af405fbc443900e2c0302cccb4d68fe3.png";